module.exports = __webpack_public_path__ + "static/media/bar-6.bfda088a.jpg";